import { random } from "core-js/core/number";
import isEqual from "react-fast-compare";

interface ObjectWithId {
    id: any;
    [propName: string]: any;
}

interface GQLArrayChanges {
    create?: ObjectWithId[],
    delete?: ObjectWithId[],
    update?: ObjectWithId[]
}

interface GQLConnectArrayChanges {
    disconnect?: any[],
    connect?: any[],
    sync?: any[]
}



type ObjectWithIdArray = Array<ObjectWithId>;

/*
* If the ID changes, it is a RELATION, so do not descend and mark as such
* If there is an ID change in an array, and another en
*/



class GQLChanges {
    childTypes: object;
    constructor(childTypes) {
        this.childTypes = childTypes;
    }
    doLog(name, output, oldVal, newVal, compare = null) {
        if (compare) {
            if (isEqual(compare, output)) {
                console.log('%cGQLTest ' + name + ' succeeded', 'color: green;');
                return;
            } else {
                console.error('GQLTest', name, 'FAILED');
            }
        }
        console.log('GQLTest', name, output, oldVal, newVal);
        console.log('GQLTest', JSON.stringify(output));
    }
    runTests() {
        this.childTypes = {
            'children': 'create',
            'children.lookup': 'connect',
            'children.lookups': 'connect',
            'children.objects': 'create'
        };
        const testSrc = function () {
            return {
                id: '1',
                children:
                // these are 'real' children'
                    [{
                        id: '2', label: 'SOURCE',
                        lookup:
                        // this is a lookup
                            {id: '3', label: 'CHILD1.1-LABEL'}
                    }
                    ]
            };
        };
        var src = testSrc();
        var output = testSrc();
        output.children[0].label = 'CHANGE';

        this.doLog('LABEL CHANGE (update)', this.compare(src, output), src, output, { "id": "1", "children": { "update": [{ "id": "2", "label": "CHANGE" }] } });

        var src = testSrc();
        var output = testSrc();
        //@ts-ignore
        output.children[0].id = '7';
        output.children[0].label = 'NEW LABEL';
        this.doLog('ID CHANGE (delete child=2/re-create)', this.compare(src, output), src, output, { "id": "1", "children": { "create": [{ "label": "NEW LABEL", "lookup": { "connect": "3" } }], "delete": ["2"] } }
        );

        var src = testSrc();
        var output = testSrc();
        output.children[0].lookup.label = 'CHANGE';
        //@ts-ignore
        output.children[0].lookup.id = 'NEW ID';
        this.doLog('CHANGE SUBROW (connect)', this.compare(src, output), src, output, { "id": "1", "children": { "update": [{ "id": "2", "lookup": { "connect": "NEW ID" } }] } }
        );

        var src = testSrc();
        var output = testSrc();
        //@ts-ignore
        src.children.pop();
        this.doLog('INSERT ROW', this.compare(src, output), src, output, { "id": "1", "children": { "create": [{ "label": "SOURCE", "lookup": { "connect": "3" } }] } }
        );

        var src = testSrc();
        var output = testSrc();
        //@ts-ignore
        src.children[0].lookup = null;
        this.doLog('CONNECT lookup', this.compare(src, output), src, output, { "id": "1", "children": { "update": [{ "id": "2", "lookup": { "connect": "3" } }] } });


        var src = testSrc();
        var output = testSrc();
        //@ts-ignore
        output.children[0].lookup = null;
        this.doLog('DISCONNECT lookup', this.compare(src, output), src, output, { "id": "1", "children": { "update": [{ "id": "2", "lookup": { "disconnect": true } }] } }
        );

        var src = testSrc();
        var output = testSrc();
        //@ts-ignore
        src.children[0].lookup = null;
        output.children[0].lookup = { id: '7', label: 'NEW LOOKUP VALUE' };
        this.doLog('CREATE lookup', this.compare(src, output), src, output, { "id": "1", "children": { "update": [{ "id": "2", "lookup": { "connect": "7" } }] } });

        const testSrcB = function () {
            return {
                id: '1',
                children:
                // these are 'real' children'
                    [{
                        id: '2', label: 'SOURCE',
                        lookups: [
                            {id: '3', label: 'CHILD1.1-LABEL'}
                        ]
                    }
                    ]
            };
        };

        var srcB = testSrcB();
        var outputB = testSrcB();
        outputB.children[0].lookups = [];
        this.doLog('Delete lookups via empty array', this.compare(srcB, outputB), srcB, outputB,
            { "id": "1", "children": { "update": [{ "id": "2", "lookups": { "disconnect": ["3"] } }] } }
        );

        var srcB = testSrcB();
        var outputB = testSrcB();
        outputB.children[0].lookups = null;
        // can't work!!
        this.doLog('Delete lookups via null', this.compare(srcB, outputB), srcB, outputB,
            { "id": "1", "children": { "update": [{ "id": "2", "lookup": { "connect": "7" } }] } });

        var srcB = testSrcB();
        var outputB = testSrcB();
        outputB.children[0].lookups = [{ id: '5', label: 'CHILD (NEW)' }];
        this.doLog('Replace lookups to array', this.compare(srcB, outputB), srcB, outputB,
            { "id": "1", "children": { "update": [{ "id": "2", "lookups": { "connect": ["5"], "disconnect": ["3"] } }] } }
        );

        var srcB = testSrcB();
        var outputB = testSrcB();
        outputB.children[0].lookups.push({ id: '5', label: 'CHILD (NEW)' });
        this.doLog('Add lookups to array', this.compare(srcB, outputB), srcB, outputB,
            { "id": "1", "children": { "update": [{ "id": "2", "lookups": { "connect": ["5"] } }] } }
        );

        var srcB = testSrcB();
        var outputB = testSrcB();
        outputB.children.push({
            id: '5',
            label: 'NEW CHILD',
            lookups: [{ id: '3', label: 'fred' }]
        });
        this.doLog('Add lookups to array', this.compare(srcB, outputB), srcB, outputB,
            { "id": "1", "children": { "create": [{ "label": "NEW CHILD", "lookups": { "connect": ["3"] } }] } }
        );
        var srcB = testSrcB();
        var outputB = testSrcB();
        outputB.children.push({
            id: '5',
            label: 'NEW CHILD',
            lookups: [null]
        });
    }
    compareArray(oldData: ObjectWithIdArray, newData: ObjectWithIdArray, path: string): GQLArrayChanges | GQLConnectArrayChanges | ObjectWithIdArray {
        if (!oldData) { oldData = []; }
        if (!newData) { newData = []; }
        const oldIndexed = {}, newIndexed = {}, allIds = [];
        oldData.forEach(v => {
            oldIndexed[v.id] = v;
            allIds[v.id] = true;
        });
        let isFiles = false;
        newData.forEach(v => {
            if (v instanceof File) {
                isFiles = true;
                return;
            }
            allIds[v.id] = true;
            newIndexed[v.id] = v;
        });
        if (isFiles) return newData;
        //        console.log('array comparing',oldIndexed,newIndexed);
        let hasupdate = false;


        if (this.childTypes[path] && this.childTypes[path] == 'connect') {
            // (re)connect
            let ret = { connect: [], disconnect: [] };// could use sync instead /shrug
            Object.keys(allIds).forEach(key => {
                if (newIndexed[key] && !oldIndexed[key]) {
                    //                    console.log('NEW, NOT OLD -> CONNECT');
                    ret.connect.push(key);
                    return;
                }
                if (oldIndexed[key] && !newIndexed[key]) {
                    //                    console.log('OLD, NOT NEW -> DISCONNECT');
                    ret.disconnect.push(key);
                }
            });
            if (!ret.connect.length && !ret.disconnect.length) return null;
            if (!ret.connect.length) { delete ret.connect; }
            if (!ret.disconnect.length) { delete ret.disconnect; }
            return ret;
        }
        let ret = { create: [], update: [], delete: [] };
// go through the array
        Object.keys(allIds).forEach(key => {
            // new object - put the ID into creation_id
            if (!oldIndexed[key]) {
                hasupdate = true;
                const tc = this.getObjectChanges({id: null}, newIndexed[key], path);
                tc.creation_id = tc.id;
                delete tc.id;
                ret.create.push(tc);
                return;
            }

            // deleted object
            if (!newIndexed[key]) {
                hasupdate = true;
                ret.delete.push(key);
                return;
            }
            const check = this.getObjectChanges(oldIndexed[key], newIndexed[key], path);
            // maybe an update
            if (check) {
                hasupdate = true;
                ret.update.push(check);
                return;
            }
        });
        if (!hasupdate) return null;
        return ret;
    }
    getObjectChanges(oldData?: ObjectWithId, newData?: ObjectWithId, path?: string): ObjectWithId {
        //        console.log('GOC',oldData,newData);
        if (oldData == newData) return null;
        if (newData instanceof File) return newData;
//        console.log('[GQLChanges]',oldData,newData,path);
        const allIds = {};
        if(oldData) {
            Object.keys(oldData).forEach(v => {
                allIds[v] = true;
            });
        }
        Object.keys(newData).forEach(v => {
            allIds[v] = true;
        });
        const changeObject: ObjectWithId = {id: newData.id};
        let seenChange = false;
        Object.keys(allIds).forEach(key => {
            const oldRow = oldData?oldData[key]:null;
            const newRow = newData[key];
            const keyPath = (path ? path + '.' : '') + key;
//            console.log('[GQLChanges]',oldRow,newRow,keyPath);
            //            console.log('CHECK OBJECT KEY ',keyPath,oldRow,newRow,typeof(newRow));

            // Force inclusion of ourContact
            if (key === 'ourContact') {
                if (newRow) {
                    changeObject[key] = { connect: newRow.id };
                } else {
                    changeObject[key] = { disconnect: true };
                }
                seenChange = true;
                return;
            }
            
            if (oldRow === undefined || oldRow === null) {
                if (newRow === undefined || newRow === null) return;
                if (Array.isArray(newRow)) {
                    const p = this.compareArray([], newRow, keyPath);
                    if (p) {
                        seenChange = true;
                        changeObject[key] = p;
                    }
                    return;
                }
                if (newRow instanceof File) {
                    seenChange = true;
                    changeObject[key] = newRow;
                    return;
                }
                if (newRow instanceof Object) {
                    seenChange = true;
                    if (this.childTypes[keyPath] && this.childTypes[keyPath] == 'connect') {
                        changeObject[key] = { connect: newRow.id };
                    } else {
                        if (key == 'campaignComponent') {
                            changeObject.qty = parseInt(newRow.qty);
                            if (newRow.region) {
                                changeObject.region_id = newRow.region.id;
                            }
                            if (newRow.regionType) {
                                changeObject.region_type_id = newRow.regionType.id;
                            }
                            if (newRow.unit_value_local) {
                                changeObject.unit_value_local = newRow.unit_value_local;
                            }
                            if (newRow.price_divisor) {
                                changeObject.price_divisor = newRow.price_divisor;
                            }
                            if(newRow.currency) {
                                changeObject.currency_id = newRow.currency?.id;
                            }
                        } else {
                            const obj = this.getObjectChanges({id: null}, newRow, keyPath);
                            delete obj.id;
                            changeObject[key] = { create: obj };
                        }
                    }
                    return;
                }
                seenChange = true;
                changeObject[key] = newRow;
                return;
            }
            if (newRow === undefined || newRow === null) {
                // TODO handle relation/child deletion properly!!!
                if (Array.isArray(oldRow)) {
                    if (this.childTypes[keyPath] && this.childTypes[keyPath] == 'connect') {
                        changeObject[key] = { disconnect: [] };
                        oldRow.forEach(v => {
                            changeObject[key].disconnect.push(v.id);
                        });
                    } else {
                        changeObject[key] = { delete: [] };
                        oldRow.forEach(v => {
                            changeObject[key].delete.push(v.id);
                        });
                    }
                }
                if (oldRow instanceof Object) {
                    //console.log('[GQLChanges]', 'DISCONNECT CHANGE');
                    seenChange = true;
                    if (this.childTypes[keyPath] && this.childTypes[keyPath] == 'connect') {
                        changeObject[key] = { disconnect: true };
                    } else {
                        changeObject[key] = { delete: true };
                    }
                    return;
                }
                changeObject[key] = newRow;
                seenChange = true;
                return;
            }
            if (newRow === oldRow) {
                return;
            }
            let populatedChanges = false;
            let changes: any = null;
            if (Array.isArray(newRow)) {
                const oR = <ObjectWithIdArray>oldRow;
                const nR = <ObjectWithIdArray>newRow;
                //console.log('compareArray',keyPath,oR,nR);
                changes = this.compareArray(oR, nR, keyPath);
                populatedChanges = !!changes;
            } else {
                if (newRow instanceof Object) {
                    if (newRow === null||newRow===undefined||newRow?.id==null) {
                        populatedChanges = true;
                        changes = { disconnect: true };
                    } else {
                        // this can only happen if it's a lookup field
                        if (newRow.id != oldRow.id) {
                            populatedChanges = true;
                            changes = { connect: newRow?.id };
                        } else {
                            const temp = this.getObjectChanges(oldRow, newRow, keyPath);
                            if (this.childTypes[keyPath] && this.childTypes[keyPath] == 'connect') {
                                if (temp) {
                                    populatedChanges = true;
                                    changes = { connect: temp.id };
                                }
                            } else {
                                if (temp) {
                                    populatedChanges = true;
                                    changes = { update: temp };
                                }
                            }
                        }
                    }
                } else {
                    populatedChanges = true;
                    changes = newRow;
                }
                //changes = true;
            }
            if (populatedChanges) {
                seenChange = true;
                changeObject[key] = changes;
            }
        });
        if (!seenChange) return null;
        return changeObject;
    }
    compare(oldData: ObjectWithId | ObjectWithIdArray, newData: ObjectWithId | ObjectWithIdArray) {
        if (Array.isArray(oldData) || Array.isArray(newData)) {
            //            var od:ObjectWithId[] = <ObjectWithIdArray> (oldData||[]);
            //          var nd:ObjectWithId[] =  newData||[];
            return this.compareArray(oldData as ObjectWithIdArray, newData as ObjectWithIdArray, '');
        }
        //console.log('GQLCHANGES as object');
        return this.getObjectChanges(oldData, newData, '');
    }
    clone(object: ObjectWithId,path) {
        if(Array.isArray(object)) {
            //console.log('clone',path,'array',object.map((v) => { this.clone(v,path)}));
            return object.map((v) => { return this.clone(v,path)});
        }
        if(object instanceof Object) {
            const retval = {};
            if(object['__typename']=='File') {
                retval['clone_id'] = object['id'];
            }
            if(this.childTypes[path] && this.childTypes[path] == 'connect') {
                Object.entries(object).forEach(([k,v])=> {
                    if(k=='__typename') return;
                    retval[k] = this.clone(v,path?path+'.'+k:k);
                });
            } else {
                Object.entries(object).forEach(([k,v])=> {
                    if(k=='__typename') return;
                    if(k=='id') { v = (String)(new Date()+'-'+Math.random()); }
                    retval[k] = this.clone(v,path?path+'.'+k:k);
                });
            }
            if(!path) {
                retval['__cloned'] = true;
            }
            console.log('CLONED',path,'vs',retval);
            return retval;
        }

        return object;
    }
}

export default GQLChanges;